import * as yup from 'yup';
import {
  AddressDataSchema,
  IAddressData,
  IUpdateAddressData,
  UpdateAddressDataSchema,
} from './IAddressData';
import {
  CommunicationDataSchema,
  ICommunicationData,
  IUpdateCommunicationData,
  UpdateCommunicationDataSchema,
} from './ICommunicationData';

export const ContactDataSchema = yup.object({
  address: AddressDataSchema.notRequired(),
  communication: CommunicationDataSchema.notRequired(),
});
export const UpdateContactDataSchema = yup.object({
  id: yup.string().required(),
  address: UpdateAddressDataSchema.notRequired(),
  communication: UpdateCommunicationDataSchema.notRequired(),
});
export interface IContactData {
  address: IAddressData;
  communication: ICommunicationData;
}
export interface IUpdateContactData {
  id: string;
  address?: IUpdateAddressData;
  communication?: IUpdateCommunicationData;
  //todo check if it's working, find a workaround if not
}
